import { render, staticRenderFns } from "./saasList.vue?vue&type=template&id=66aa6290&scoped=true"
import script from "./saasList.vue?vue&type=script&lang=js"
export * from "./saasList.vue?vue&type=script&lang=js"
import style0 from "./saasList.vue?vue&type=style&index=0&id=66aa6290&prod&lang=scss"
import style1 from "./saasList.vue?vue&type=style&index=1&id=66aa6290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa6290",
  null
  
)

export default component.exports